export enum FirmwareUpdateStatus {
  InProgress = 'start',
  Success = 'success',
  Fail = 'fail',
  Reboot = 'firmware_update',
  Boot = 'boot'
};
